export type Aggregation = 'P50' | 'P80' | 'AVERAGE';

export const aggregationOptions: ISelectOption<Aggregation>[] = [
    { label: 'Average', value: 'AVERAGE' },
    { label: 'P50 (Median)', value: 'P50' },
    { label: 'P80 (High)', value: 'P80' },
];
